<template>
    <pm-custom-dialog v-if="visible" v-model="visible">


        <div style="background: url(/images/onboarding/onboarding-consultation.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 170px;"></div>

        <div style="margin-bottom: 16px; text-align: center;">
            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">Take your consultations<br/>to the next level!</h2>
        </div>

        <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">


            Subscribe to DentiCalc PREMIUM and...


            Create personalized animations. Your patients will be more involved<br/>
            Show the finest deatils in unique animations.<br/>
            Give prices in seconds and prevent<br/>
            Print the offer or send it to you patient<br/>

        </p>
        <br/>
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">
            <br/>
            <span @click="close" style="text-decoration: underline;">close</span>
        </div>

    </pm-custom-dialog>
</template>
<script>
import PmIapProductButton from "@/components/core/iap-product-button.vue";
import PmPrivacyLinks from "../addons/privacy-links";
import PmCustomDialog from "./base-dialog.vue";
export default {
    components: {
        PmCustomDialog,
        PmIapProductButton,
        PmPrivacyLinks
    },
    data: () => ({
        visible: false,
    }),
    created() {

    },
    methods: {
        show() {
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
    }
}
</script>
